import Head from 'next/head'
import { useContext, useEffect, useState } from 'react'
import { GetServerSideProps } from 'next'
import { getBVScriptUrl } from '../utils/bazaarvoice'
import { useAuthAPI } from '../hooks/api.hooks'
import Context from '../context'

const BazaarvoiceContainer = ({ bvScriptUrl }: { bvScriptUrl: string }) => {
  const { state } = useContext(Context)
  const authAPICall = useAuthAPI()
  const [bvToken, setBvToken] = useState<string | null>(null)

  useEffect(() => {
    const loadBvToken = async () => {
      if (state.user?.UID && state.user?.email && state.user?.authType !== 0) {
        const tokenData = await authAPICall('user', 'bvtoken', 'POST', {
        }, {
          userEmail: state.user.email
        }, {
          customerid: state.user.UID
        })
        setBvToken(tokenData?.UAS)
      }
    }

    loadBvToken()
  }, [state.user])

  return (
    <>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href="/bazaarvoice-container" />
        <meta name="bv:pageType" content="container" />
        {bvToken && <meta name="bv:userToken" content={bvToken} />}
        <title></title>
      </Head>
      <script async src={bvScriptUrl}></script>
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async () => {
  const bvScriptUrl = getBVScriptUrl()

  return {
    props: {
      bvScriptUrl
    }
  }
}

export default BazaarvoiceContainer
